
import { defineComponent, ref } from "vue";
export default defineComponent({
    name: "Head",
    props: {
        addTodo: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const title = ref('');
        const add = () => {
            const text = title.value;
            if (text) {
                props.addTodo({
                    id: Date.now(),
                    title: text,
                    isChecked: false,
                })
                title.value = '';
            } 
        }
        return {
            add,
            title,
        }
    }
});
